import styled from 'styled-components';

export const Container = styled.div`
  margin: 2rem 0;
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: #006592;
  }
`;
